// 1. Save Currently Viewed Product to Local Storage
function setRecentlyViewedProduct() {
  const track = document.querySelector('[id^="rv-slider-track-"]');
  if (!track) return;

  const currentHandle = track.getAttribute('data-product-handle');
  if (!currentHandle) return;

  let viewedProducts = JSON.parse(localStorage.getItem('recently_viewed')) || [];
  
  // Remove duplicate if it already exists
  viewedProducts = viewedProducts.filter(handle => handle !== currentHandle);
  
  // Add current product to start of array
  viewedProducts.unshift(currentHandle);
  
  // Keep up to 12 items
  if (viewedProducts.length > 12) viewedProducts.pop();

  localStorage.setItem('recently_viewed', JSON.stringify(viewedProducts));
}

// 2. Fetch and Render the Products Layout
function renderRecentlyViewed() {
  const track = document.querySelector('[id^="rv-slider-track-"]');
  if (!track) return;

  const viewedProducts = JSON.parse(localStorage.getItem('recently_viewed')) || [];
  const currentHandle = track.getAttribute('data-product-handle');

  // Filter out the current product from displaying in its own recommended row
  const filteredProducts = viewedProducts.filter(handle => handle !== currentHandle);

  if (filteredProducts.length === 0) {
    const emptyMsg = document.querySelector('.rv-empty-msg');
    if (emptyMsg) emptyMsg.style.display = 'block';
    return;
  }

  // Detect current active currency (e.g., "INR", "USD") from Shopify, default to "INR" if undetected
  const currencyCode = (window.Shopify && Shopify.currency && Shopify.currency.active) ? Shopify.currency.active : 'INR';

  // Fetch product data from Shopify AJAX API
  filteredProducts.forEach(handle => {
    fetch(`/products/${handle}.js`)
      .then(res => res.json())
      .then(product => {
        // Base formatting configurations with the currency tag attached to the end
        let formattedPrice = Shopify.formatMoney ? Shopify.formatMoney(product.price) : `₹ ${(product.price / 100).toFixed(2)}`;
        let formattedCompare = product.compare_at_price ? (Shopify.formatMoney ? Shopify.formatMoney(product.compare_at_price) : `₹ ${(product.compare_at_price / 100).toFixed(2)}`) : '';
        
        // Append currency text if it isn't already included by Shopify.formatMoney
        if (!formattedPrice.includes(currencyCode)) { formattedPrice += ` ${currencyCode}`; }
        if (formattedCompare && !formattedCompare.includes(currencyCode)) { formattedCompare += ` ${currencyCode}`; }

        const hasSale = product.compare_at_price > product.price;

        const productHtml = `
          <div class="rv-product-card">
            <div class="rv-image-container">
              ${hasSale ? '<span class="rv-badge">SALE</span>' : ''}
              <img src="${product.featured_image}" alt="${product.title}" class="rv-product-img">
            </div>
            <div class="rv-product-info">
              <h3 class="rv-product-title">${product.title}</h3>
              <div class="rv-price-container">
                <span class="rv-current-price">${formattedPrice}</span>
                ${hasSale ? `<span class="rv-old-price">${formattedCompare}</span>` : ''}
              </div>
              <form method="post" action="/cart/add">
                <input type="hidden" name="id" value="${product.variants[0].id}" />
                <button type="submit" class="rv-add-to-cart">Add to cart</button>
              </form>
              <a href="${product.url}" class="rv-learn-more">Learn More</a>
            </div>
          </div>
        `;
        track.insertAdjacentHTML('beforeend', productHtml);
      })
      .catch(err => console.error("Error loading recently viewed product:", err));
  });

  initializeSliderControls();
}

// 3. Slider Functionality Logic
function initializeSliderControls() {
  setTimeout(() => {
    const track = document.querySelector('[id^="rv-slider-track-"]');
    const secId = track.id.replace('rv-slider-track-', '');
    const nextBtn = document.getElementById(`rv-next-${secId}`);
    const prevBtn = document.getElementById(`rv-prev-${secId}`);

    if (!track || !nextBtn || !prevBtn) return;

    let currentIndex = 0;

    function getVisibleCardsCount() {
      const width = window.innerWidth;
      if (width > 992) return 4;
      if (width > 768) return 3;
      return 2;
    }

    function moveSlider() {
      const card = track.querySelector(".rv-product-card");
      if (!card) return;
      const cardWidth = card.getBoundingClientRect().width;
      const gap = 20; 
      track.style.transform = `translateX(-${currentIndex * (cardWidth + gap)}px)`;
    }

    nextBtn.addEventListener("click", () => {
      const totalCards = track.querySelectorAll(".rv-product-card").length;
      const visibleCards = getVisibleCardsCount();
      if (currentIndex < totalCards - visibleCards) { currentIndex++; } else { currentIndex = 0; }
      moveSlider();
    });

    prevBtn.addEventListener("click", () => {
      const totalCards = track.querySelectorAll(".rv-product-card").length;
      const visibleCards = getVisibleCardsCount();
      if (currentIndex > 0) { currentIndex--; } else { currentIndex = Math.max(0, totalCards - visibleCards); }
      moveSlider();
    });
  }, 800);
}

// Fire Scripts
document.addEventListener("DOMContentLoaded", function () {
  setRecentlyViewedProduct();
  renderRecentlyViewed();
});